import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Directive({
  selector: '[appHiddenElement]',
  standalone: false,
})
export class HiddenElementDirective implements OnInit {
  @Input() idE: string;
  @Input() isDifferent: boolean;
  @Input() url: string = '/dashboard';
  @Input() hiddenInError: boolean;

  constructor(
    private el: ElementRef,
    private router: Router,
  ) {}

  ngOnInit() {
    this.initComponent(this.router.url);
    this.router.events.subscribe((event: NavigationEnd) => {
      if (event instanceof NavigationEnd) {
        this.initComponent(event.url);
      }
    });
  }

  initComponent(url: string) {
    if (url.indexOf('/dashboard/error') > -1 && this.hiddenInError) {
      this.el.nativeElement.classList.add('hidden-element');
      return;
    }
    if (this.isDifferent) {
      this.hiddenDiferet(url);
    } else {
      this.hiddenEqual(url);
    }
  }

  get element() {
    return this.el.nativeElement as HTMLElement;
  }

  private hiddenEqual(url) {
    if (url === this.url) {
      this.el.nativeElement.classList.remove('hidden-element');
    } else {
      this.el.nativeElement.classList.add('hidden-element');
    }
  }

  private hiddenDiferet(url) {
    if (url !== this.url) {
      this.el.nativeElement.classList.remove('hidden-element');
    } else {
      this.el.nativeElement.classList.add('hidden-element');
    }
  }
}
